import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthUser { id: number; login: string; group: string; isAdmin: boolean; }
interface AuthState { value: boolean; user: AuthUser | null; }

// Synchronous init from localStorage — no flash redirect to /login
const initFromToken = (): AuthState => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return { value: false, user: null };
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.exp * 1000 < Date.now()) {
      localStorage.removeItem('token');
      return { value: false, user: null };
    }
    return {
      value: true,
      user: { id: payload.id, login: payload.login, group: payload.group, isAdmin: payload.isAdmin },
    };
  } catch {
    return { value: false, user: null };
  }
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: initFromToken(),
  reducers: {
    setAuth: (state, action: PayloadAction<boolean>) => { state.value = action.payload; },
    setUser: (state, action: PayloadAction<AuthUser | null>) => { state.user = action.payload; },
  },
});

export const { setAuth, setUser } = authSlice.actions;
export default authSlice.reducer;
